import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ToolbarItem, ToolbarButton as WebToolbarButton } from 'components/UI';
import { FunctionComponent, PropsWithChildren } from 'react';
import MobileToolbarButton from './MobileToolbarButton';

export interface ToolbarButtonProps extends PropsWithChildren {
    disabled?: boolean;
    className?: string;
    options: Array<ToolbarOption>;
}

export interface ToolbarOption {
    id: string;
    label: string;
    icon: IconDefinition;
    color?: string;
    onClick: () => void;
}

export const ToolbarButton: FunctionComponent<ToolbarButtonProps> = props => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return isMobile ? (
        <MobileToolbarButton
            options={props.options}
            disabled={props.disabled}
        />
    ) : (
        <WebToolbarButton disabled={props.disabled}>
            {props.options.map(option => (
                <ToolbarItem
                    key={option.id}
                    icon={option.icon}
                    text={option.label}
                    onClick={option.onClick}
                    color={option.color}
                />
            ))}
        </WebToolbarButton>
    );
};

export default ToolbarButton;
